import { useMemo } from 'react';
import { useStateFromUrl } from '~/hooks/useStateFromUrl';
import { defaultAgreementStatusFilter, deserializeFiltersFromURL } from '../agreementsDashboardFilters';
export function useAgreementsUrlFilters(approvalDateEnabled) {
    const { urlState, changeUrlState } = useStateFromUrl({
        search: {
            defaultValue: ''
        },
        agreementStatus: {
            multi: true,
            applyDefaultOnlyOnMount: true,
            defaultValue: defaultAgreementStatusFilter
        },
        effectiveDate: {
            defaultValue: ''
        },
        approvalDate: {
            defaultValue: ''
        },
        lastBillingDate: {
            defaultValue: ''
        },
        paymentMethod: {
            multi: true
        },
        completion: {
            multi: true
        },
        recurrence: {
            multi: true
        },
        hasCredit: {
            multi: true
        },
        automatic: {
            multi: true
        },
        billingTrigger: {
            multi: true
        },
        serviceNames: {
            multi: true
        },
        servicePriceIncreaseState: {
            multi: true
        },
        hasAmendments: {
            multi: true
        },
        amendmentsStatus: {
            multi: true
        }
    });
    const filters = useMemo(()=>deserializeFiltersFromURL(urlState, approvalDateEnabled), [
        urlState,
        approvalDateEnabled
    ]);
    return {
        search: urlState.search,
        filters,
        changeUrlState
    };
}
